<template>
    <div class="dealer-locator__filter">
        <h3 class="dealer-locator__filter--title">{{ title }}</h3>

        <div class="dealer-locator__filter--content">
            <slot />
        </div>
    </div>
</template>

<script>
    import { defineComponent } from "vue";

    export default defineComponent({
        props: {
            title: String
        }
    })
</script>